// import { useEffect, useState } from 'react';
// import { Link as RouterLink, useNavigate } from 'react-router-dom';
// // import MHidden from '../components/@material-extend/MHidden';
// import LoginForm from '../components/LoginForm';
// // import LArt from '../assets/illustration_login.png';
// // import { RootStyle, SectionStyle, ContentStyle } from '../types/LoginStyles';
// import Cookies from 'js-cookie';
// import LArt from '../assets/illustration_login.png';

import { Box, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LArt from '../assets/illustration_login.png';
import MHidden from '../components/@material-extend/MHidden';
import LoginForm from '../components/LoginForm';

// import { RootStyle, SectionStyle, ContentStyle } from '../types/LoginStyles';

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    if (Cookies.get('token') && window.location.pathname === '/login') {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1e1e2f, #2d2e48)',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
        fontFamily: 'Lato, sans-serif',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1100px',
          backgroundColor: '#2b2c3e',
          borderRadius: '20px',
          display: 'flex',
          overflow: 'hidden',
          boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
          position: 'relative',
        }}
      >
        {/* 🔷 Left Side with Image and Branding */}
        <MHidden width='mdDown'>
          <Box
            sx={{
              flex: 1,
              backgroundColor: '#1e1f2f',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              px: 4,
              py: 6,
            }}
          >
            <Typography
              variant='h3'
              sx={{
                fontWeight: 'bold',
                color: '#6871d1',
                mb: 3,
                textAlign: 'center',
                fontFamily: 'Lato, sans-serif',
              }}
            >
              Scrapify
            </Typography>

            <img
              src={LArt}
              alt='Login Illustration'
              style={{
                width: '100%',
                maxWidth: '420px',
                filter: 'drop-shadow(0 0 20px rgba(104,113,209,0.3))',
                borderRadius: '12px',
              }}
            />
          </Box>
        </MHidden>

        {/* Right Side - Login Form */}
        <Box
          sx={{
            flex: 1,
            p: 6,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: '#2b2c3e',
            color: '#fff',
            fontFamily: 'Lato, sans-serif',
            animation: 'fadeInUp 0.8s ease-in-out',
            '@keyframes fadeInUp': {
              from: { opacity: 0, transform: 'translateY(30px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          <Typography variant='h5' fontWeight='bold' gutterBottom color='#6871d1'>
            Welcome back 👋
          </Typography>

          <Typography sx={{ color: '#aaa', mb: 4 }}>Enter your credentials to sign in.</Typography>

          <LoginForm />
        </Box>
      </Box>
    </Box>
  );
}
